<script>
import { centsToDollars } from './../../../../utils/format-price'
import { trialDays } from './../../../../configuration'

export default {
    name: 'SubscriptionTile',

    props: {
        plan: {
            type: Object,
            default: () => {},
        },
        currentSubscription: {
            type: Object,
            default: () => {},
        },
        isLoggedIn: {
            type: Boolean,
            default: false,
        },
        isEntitledFreeTrial: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            trialDays,
        }
    },

    computed: {
        isCurrentPlan() {
            if (!this.currentSubscription) return false
            return this.plan?.id === this.currentSubscription?.subscriptionsProductsId.id
        },
        isAnUpgrade() {
            if (!this.currentSubscription) return false
            return this.plan?.id > this.currentSubscription?.subscriptionsProductsId.id
        },
    },

    methods: {
        centsToDollars,
        actionText(durationTrialDays) {
            // Special case for yearly plan
            if (this.plan.durationMonths === 12) return 'Go yearly and save'
            if (!this.isLoggedIn) return 'GET STARTED'
            if (this.isCurrentPlan) return 'YOUR ACTIVE PLAN'
            if (this.isEntitledFreeTrial && durationTrialDays) return 'START FREE TRIAL'
            else return 'UPGRADE'
        },
    },
}
</script>

<template>
    <div :class="[$style.tile, { [$style.yearlyTile]: plan.durationMonths === 12 }]">
        <div
            v-if="plan.durationMonths === 12"
            :class="$style.popularBadge"
        >Most Popular</div>
        <BaseSection>
            <h2 :class="$style.title">{{ plan.title }}</h2>
            <h3 :class="$style.price">{{ centsToDollars(plan.price / plan.durationMonths) }} / month <span v-if="plan.durationMonths === 12">(Save 20%!)</span></h3>
            <p
                v-if="plan.durationMonths === 12"
                :class="$style.subtitle"
            >
                {{ centsToDollars(plan.price) }} billed annually.
            </p>
            <ul :class="$style.salesPoints">
                <li :class="$style.salesPoint">High quality audio</li>
                <li :class="$style.salesPoint">No ads</li>
                <li :class="$style.salesPoint">Download mixes, listen offline on mobile</li>
                <li :class="$style.salesPoint">VIP access: skip the line and access new mixes before everyone else</li>
                <br v-if="!isLoggedIn && plan.durationMonths === 1">
                <li
                    v-if="!isLoggedIn && plan.durationMonths === 1"
                    :class="$style.salesPoint"
                >{{ trialDays }}-day free trial (if you haven't yet tried Premium).</li>
            </ul>
            <div :class="$style.action">
                <BaseButton
                    :button-type="plan.current ? 'tag' : 'highlight'"
                    :modifiers="{ fill: true, noMargins: true }"
                    :disabled="isCurrentPlan"
                    :aria-disabled="plan.current"
                    :class="$style.actionButton"
                    @click="$emit('onAction', plan)"
                >{{ actionText(plan.durationTrialDays) }}</BaseButton>
                <p :class="$style.disclaimer">No strings attached. Cancel anytime.</p>
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.tile {
    position: relative;
    width: 330px;
    min-height: 425px;
    padding: 0 $s-xl;
    text-align: left;
    background: $c-black-grey-gradient;
    border-radius: 6px;
    box-shadow: 0 12px 24px 0 rgba(16, 17, 24, 0.27);

    &:nth-of-type(1) {
        background: $c-alt-bg;
    }
}

.yearlyTile {
    border: 2px solid $c-highlight;
}

.popularBadge {
    position: absolute;
    top: -$s-xs;
    left: 50%;
    z-index: 1;
    padding: $s-xs $s-l;
    font-size: 8px;
    font-weight: 600;
    color: $c-white;
    letter-spacing: 1px;
    background: $c-highlight;
    border-radius: 10px;
    transform: translateX(-50%);
}

.title {
    margin: 0 0 $s-s;
    font-size: 28px;
    font-weight: 400;
    line-height: 24px;
}

.price {
    margin: 0 0 $s-xxs;
    font-size: 18px;
    font-weight: 300;
    line-height: 1;
}

.subtitle {
    margin: 0;
    font-size: 9px;
    line-height: 1;
}

.action {
    position: absolute;
    right: 0;
    bottom: $s-xl;
    left: 0;
    width: 100%;
    padding: 0 $s-l;
    margin: 0 auto;

    .actionButton {
        font-weight: 800;
    }
}


.disclaimer {
    @extend %contentSubtitleM;

    margin: $s-s 0 0 0;
    font-size: 11px;
    line-height: 1.2;
    color: $c-text-faded;
    text-align: center;
}

.salesPoints {
    @extend %contentSubtitleM;

    padding: 0;
    margin-top: $s-xl;
    list-style: none;
}

.salesPoint {
    font-size: 13px;
    font-weight: 300;
    line-height: 1.2;

    &.highlight {
        font-weight: 400;
        color: $c-white;
    }
}

.salesPoint ~ .salesPoint {
    margin-top: $s-s;
}

@include tablet {
    .tile {
        padding-top: $s-xl;
    }

    .salesPoints {
        margin-top: $s-xxl;
    }
}
</style>
